import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getPosts } from "@tCentro/Services/NISHomePageCategoriesService";

// Strong typing for posts
export interface PostModel {
    userId: number;
    id: number;
    title: string;
    categories: [];
}

// Props passed to the handler (includes onSuccess)
type Props = HasOnSuccess<PostModel[]>;

// What the handler will return
interface ReturnType {
    apiResult: PostModel[];
}

type HandlerType = ApiHandler<Props, ReturnType>;

export const Posts: HandlerType = async props => {
    const result = await getPosts(); // result: PostModel[]

    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(result);
    }

    // Set the result on props, if needed by the chain, or just return void
    // (Assuming the handler chain expects you to mutate props, not return a value)
    // props.apiResult = result; // Uncomment if needed by your framework
};
export const chain = [Posts];

const postDatas = createHandlerChainRunner(chain, "postDatas");
export default postDatas;
